import React from 'react';
import { useIntersectionObserver } from './useIntersectionObserver';
export function OldMethodsFail() {
  const {
    elementRef,
    isVisible
  } = useIntersectionObserver();
  return <section className="bg-navy-dark py-16 md:py-24" data-id="element-276">
      <div ref={elementRef} className={`max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 fade-in-section ${isVisible ? 'is-visible' : ''}`} data-id="element-277">
        <div className="space-y-6 text-gray-200" data-id="element-278">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-gold-primary mb-8" data-id="element-279">
            Quizás ya intentaste algo diferente antes.
          </h2>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-280">
            Fuiste con otro preparador. Igual.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-281">
            Usaste TurboTax. Te preguntó lo que ya sabías.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-282">
            Le pediste ayuda a alguien de la familia. Repitió los mismos errores
            que tú.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed font-bold text-white mt-8" data-id="element-283">
            El problema no eres tú.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-284">
            El problema es que todas esas opciones trabajan con lo que{' '}
            <span className="text-gold-light font-semibold" data-id="element-285">YA SABES</span>.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed" data-id="element-286">
            Y lo que no sabes... queda afuera.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed text-gray-400 mt-8" data-id="element-287">
            Nadie te pregunta:
          </p>

          <div className="space-y-4 mt-6" data-id="element-288">
            <div className="bg-navy-light p-5 md:p-6 rounded-xl border border-gold-primary/20" data-id="element-289">
              <p className="text-lg md:text-xl text-gold-light italic" data-id="element-290">
                "¿Enmendaste tus taxes de los últimos 3 años?"
              </p>
            </div>

            <div className="bg-navy-light p-5 md:p-6 rounded-xl border border-gold-primary/20" data-id="element-291">
              <p className="text-lg md:text-xl text-gold-light italic" data-id="element-292">
                "¿Tu hijo trabaja? ¿Sabes que aún lo puedes reclamar como
                dependiente?"
              </p>
            </div>

            <div className="bg-navy-light p-5 md:p-6 rounded-xl border border-gold-primary/20" data-id="element-293">
              <p className="text-lg md:text-xl text-gold-light italic" data-id="element-294">
                "¿Le tocó pagar al IRS? ¿Sabes cómo convertir esa deuda en una
                ventaja financiera?"
              </p>
            </div>
          </div>

          <p className="text-xl md:text-2xl leading-relaxed mt-8" data-id="element-295">
            Nadie pregunta eso. Porque si lo preguntaran... tendrían que
            ayudarte a reclamar más.
          </p>

          <p className="text-xl md:text-2xl leading-relaxed text-gray-400" data-id="element-296">
            Y eso significa más trabajo para ellos por el mismo precio que te
            cobran.
          </p>
        </div>
      </div>
    </section>;
}